import { render } from "./DefitinionsRoles.vue?vue&type=template&id=7696ee00"
import script from "./DefitinionsRoles.vue?vue&type=script&lang=js"
export * from "./DefitinionsRoles.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__